import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import {toast} from "react-toastify";


export const types = {
    INIT: 'SECURITY/INIT',
    LOGIN_SUCCESS: 'SECURITY/LOGIN_SUCCESS',
    SESSION_TIMEOUT: 'SECURITY/SESSION_TIMEOUT',
};

export const initialState = fromJS({
    user: {
        isAuthenticated: sessionStorage.getItem("authToken") ? true : false,
        isFetching: sessionStorage.getItem("authToken") ? false : true,
        authToken: sessionStorage.getItem("authToken"),
        name: sessionStorage.getItem("username")
    },
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.LOGIN_SUCCESS:
            return state.set('user', fromJS(action.user));
        case types.SESSION_TIMEOUT:
            return state.set('user', fromJS(action.user));
        default:
            return state
    }
};

export const logoutUser = () => {
    return dispatch => {
        dispatch(sessionTimout());
    }
};

export const loginUser = (user, password) => {

    let params = {
        username: user,
        password: password
    };

    const path = __API__ + '/api/login';

    return dispatch => {
        return axios.post(path, params)
            .then(function (response) {
                let authToken = response.headers["auth-token"];
                if (!authToken) {
                    return;
                }
                dispatch(receiveLogin({
                    authToken: authToken
                }));
            })
            .catch(err => {
                toast.error('Beim Anmelden ist ein Fehler aufgetreten.');
            });
    }
};

const receiveLogin = (user) => {
    sessionStorage.setItem("authToken", user.authToken);
    sessionStorage.setItem("username", user.username);
    axios.defaults.headers.common['Auth-Token'] = user.authToken;

    return {
        type: types.LOGIN_SUCCESS,
        user: {
            isFetching: false,
            isAuthenticated: true,
            authToken: user.authToken,
            username: user.username
        }
    }
};

const sessionTimout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("username");
    delete axios.defaults.headers.common['Auth-Token'];

    return {
        type: types.SESSION_TIMEOUT,
        user: {
            isFetching: false,
            isAuthenticated: false,
            authToken: null,
            username: null
        }
    }
};



// WEBPACK FOOTER //
// ./src/admin/security/reducer.js